import React, { useState, useEffect, useCallback } from "react";

import { useParams } from 'react-router-dom';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Text,
  Heading,
    Flex,
  VStack,
  Tbody,
  Table,
  Tr,
  Td,
  Th,
  Thead,
  IconButton,
  HStack,
  Badge,
  Button,
  useToast,
  useColorModeValue,
  useDisclosure,
    Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
SimpleGrid,
  Accordion,
  AccordionPanel,
  AccordionIcon,
  AccordionItem,
AccordionButton,

} from "@chakra-ui/react";
import axios from "axios";
import { FiTrash, FiCheck, FiX, FiEdit } from "react-icons/fi";
import { jwtDecode } from "jwt-decode";
import { PracticeSet,QuestionSet, PracticeSetQset, QuestionSetCategory,PracticeSetSection, PracticeSetGroup, PracticeSetExam, PracticeSetSectionDetails } from '../../Platform/Common/types';
import { addMinutes } from 'date-fns'; // You can also manually add mins without this
import ReactSelect from 'react-select';
import { useNavigate } from "react-router-dom";
import { Product } from '../../Platform/Common/types';
import PracticeSetGroupQsets from "../Components/PracticeSetGroupQsets";
import PracticeSetExamQsets from "./PracticeSetExamQsets";



interface PracticeSetSectionsProps {
    practiceSetId:number;
    isPsetEditing:boolean;
  }


  const PracticeSetSections: React.FC<PracticeSetSectionsProps> = ({ practiceSetId, isPsetEditing}) => {
    // ────────────────────────────────────────────────────────────────────────────
    // Theme & routing hooks
    // ────────────────────────────────────────────────────────────────────────────

    const cardbg = useColorModeValue("gray.50", "gray.700");
  
  //  const { practice_set_id } = useParams<{ practice_set_id: string }>();
    //const [practiceSetId, setPracticeSetId] = useState<number>(Number(practice_set_id));
    const navigate = useNavigate();
    const toast = useToast();

  
    // ────────────────────────────────────────────────────────────────────────────
    // State: core practiceSet, question-sets, mappings
    // ────────────────────────────────────────────────────────────────────────────

    const [practiceSetSections, setPracticeSetSections] = useState<PracticeSetSectionDetails[]>([]);

  
    const [newSectionName, setNewSectionName] = useState<string>(""); // Initialize with an empty string

    const [newGroupName, setNewGroupName] = useState<string>(""); // Initialize with an empty string

    const [activeSection, setActiveSection] = useState<PracticeSetSectionDetails | null>(null);

    // ────────────────────────────────────────────────────────────────────────────
    // Mode & button logic
    // ────────────────────────────────────────────────────────────────────────────

   
    const [availableQuestionSets, setAvailableQuestionSets] = useState<QuestionSet[]>([]);
    const [allQuestionSets, setAllQuestionSets] = useState<QuestionSet[]>([]);


    const { isOpen, onOpen, onClose } = useDisclosure(); // Modal controls

     const {
        isOpen: isEditOpen,
        onOpen: onEditOpen,
        onClose: onEditClose,
      } = useDisclosure();
      const {
        isOpen: isDeleteOpen,
        onOpen: onDeleteOpen,
        onClose: onDeleteClose,
      } = useDisclosure();

      const buttonBg = useColorModeValue(
        'linear-gradient(to right, blue.50, blue.100)',
        'linear-gradient(to right, blue.600, blue.700)'
      );

        const buttonHoverBg = useColorModeValue(
          'blue.200',
          'blue.500'
        );

       const {
         isOpen: isGroupNewOpen,
         onOpen: onGroupNewOpen,
         onClose: onGroupNewClose,
       } = useDisclosure();
  
  
    // ────────────────────────────────────────────────────────────────────────────
    // API fetchers
    // ────────────────────────────────────────────────────────────────────────────

    // Write fetchPracticeSetCategories, API has been written and then use Accordion logic - take help from ReviewCourseTerms

    const fetchPracticeSetSections = async () => {
      const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      const { data } = await axios.get<PracticeSetSectionDetails[]>(`${b2c_apiurl}/practice-set/${practiceSetId}/sections`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
      });
      setPracticeSetSections(data);
    };

    const fetchAvailableQuestionSets = async () => {
        const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
/*       const { data } = await axios.get<QuestionSet[]>(`${b2c_apiurl}/qsets`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
        }); */
        const { data } = await axios.get<QuestionSet[]>(`${b2c_apiurl}/practice-set/${practiceSetId}/available-qsets`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
        });
        setAvailableQuestionSets(data);
    };

        const fetchAllQuestionSets = async () => {
          const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
          const { data } = await axios.get<QuestionSet[]>(`${b2c_apiurl}/qsets`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
          });
    
          setAllQuestionSets(data);
        };
      

    // 1) On load —  fetch everything
    useEffect(() => {
      (async () => {
        const token = localStorage.getItem("b2c_token");
        if (!token) return;
  
  
        if (Number(practiceSetId) > 0) {
          await fetchPracticeSetSections();
      //    await fetchQuestionSetCategories();

        await fetchAvailableQuestionSets();
        await fetchAllQuestionSets();

        }

      })();
    }, [practiceSetId]);

        const refreshAvailabilityAfterCommit = async () => {
        await fetchAvailableQuestionSets();
        await fetchAllQuestionSets();
      };
  


  
    // ────────────────────────────────────────────────────────────────────────────
    // Form handlers
    // ──────────────────────────────────────────────────────────────────────────

  
    // ────────────────────────────────────────────────────────────────────────────
    // Save / Create / Update / Publish / Cancel / Terminate
    // ────────────────────────────────────────────────────────────────────────────

      const handleAddNewSection = async () => {
        if (!newSectionName) {
          toast({
            title: "Error",
            description: "Please enter a display label for the new section.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }
    
        try {
          const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
          const response = await axios.post(
            `${b2c_apiurl}/practice-set/${practiceSetId}/add-section`,
            { practice_set_id:practiceSetId,
              title: newSectionName, 
              sequence_number:practiceSetSections.length+1,
            }, // API expects title
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("b2c_token")}`,
              },
            }
          );
          toast({
            title: "Section Added",
            description: "The new section was successfully created.",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          setNewSectionName(""); // Reset the input field
          fetchPracticeSetSections();
          onClose(); // Close the modal
          // Optionally, refresh terms list
        } catch (error) {
          console.error("Failed to add new section", error);
          setNewSectionName(""); // Reset the input field
          onClose(); // Close the modal
          toast({
            title: "Error",
            description: "Failed to add new section.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
        }

      
    const handleAddNewGroup = async (sectionId : number) => {
        if (!newGroupName) {
          toast({
            title: "Error",
            description: "Please enter a display label for the new section.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }
    
        try {
          const groupSequence = activeSection?.practice_set_groups.length ?? 0;
          const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
          const response = await axios.post(
            `${b2c_apiurl}/practice-set/${practiceSetId}/section/${sectionId}/add-qset-group`,
            { practice_set_id:practiceSetId,
              section_id:sectionId,
              title: newGroupName,
              sequence_number:groupSequence+1,
            }, // API expects title
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("b2c_token")}`,
              },
            }
          );
          toast({
            title: "Group Added",
            description: "The new section was successfully created.",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          setNewGroupName(""); // Reset the input field
          fetchPracticeSetSections();
        //  fetchQuestionSetCategories();
          onGroupNewClose(); // Close the modal
         // loadAllData();
          // Optionally, refresh terms list
        } catch (error) {
          console.error("Failed to add new group", error);
          setNewGroupName(""); // Reset the input field
          onGroupNewClose(); // Close the modal
          toast({
            title: "Error",
            description: "Failed to add new group.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
        }

        const handleGroupDeleted = (sectionId: number, groupId: number) => {
            setPracticeSetSections(prevSections =>
                prevSections.map(section => {

                    // Only operate on the target section
                    if (section.practice_set_section_id !== sectionId) return section;

                    // Remove the group
                    const updatedGroups = section.practice_set_groups
                        .filter(group => group.practice_set_group_id !== groupId)
                        // Re-sequence after deletion
                        .map((group, idx) => ({
                            ...group,
                            sequence_number: idx + 1
                        }));

                    return {
                        ...section,
                        practice_set_groups: updatedGroups
                    };
                })
            );
        };


        const isLastGroup = (
            sectionId: number,
            groupId: number,
            groupSequence: number
        ) => {
            const section = practiceSetSections.find(
                sec => sec.practice_set_section_id === sectionId
            );

            if (!section) return false;

            const totalGroups = section.practice_set_groups.length;

            // allow delete ONLY if this is the last sequence item
            return totalGroups === groupSequence;
        };

        const handleSectionInputChange = (
        sectionId: number,
        e: React.ChangeEvent<HTMLInputElement>
        ) => {
        const { name, value } = e.target;

        setPracticeSetSections((prev) =>
            prev.map((section) =>
            section.practice_set_section_id === sectionId
                ? {
                    ...section,
                    [name]: value, // updates "title"
                }
                : section
            )
        );
        };

    
        const handleDeletePracticeSetSection = async (sectionId: number) => {
            const b2c_apiurl =
                process.env.REACT_APP_B2C_API_URL || "https://default-url.com";

            try {
                await axios.delete(
                    `${b2c_apiurl}/practice-set/${practiceSetId}/section/${sectionId}/delete`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("b2c_token")}`,
                        },
                    }
                );

                // 🔥 Remove from local state so UI updates immediately
                setPracticeSetSections((prev) =>
                    prev.filter(
                        (section) => section.practice_set_section_id !== sectionId
                    )
                );

                toast({ title: "Practice Set Section Deleted", status: "success" });

                await refreshAvailabilityAfterCommit();

            } catch (err) {
                console.error(err);
                toast({ title: "Error deleting PracticeSetSection", status: "error" });
            }
        };


        const handleUpdatePracticeSetSection = async (section : PracticeSetSection) => {
            const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
            // guard

            try {
                await axios.put(`${b2c_apiurl}/practice-set/${practiceSetId}/section/${section.practice_set_section_id}/update`, section, {
                    headers: { Authorization: `Bearer ${localStorage.getItem("b2c_token")}` },
                });
                toast({ title: "PracticeSet Section updated", status: "success" });
             //   setIsPracticeSetSectionEdited(false);
    
            } catch (err) {
            console.error(err);
            toast({ title: "Error updating PracticeSetSection", status: "error" });
            }
        };



  return (
    <Box as="main" mx="auto" >

    {/* PracticeSet Sections */}

       {/* Modal for adding a new section */}
       <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Create a New Section</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Enter new Section Name"
              value={newSectionName}
              onChange={(e) => setNewSectionName(e.target.value)}
            />
            <Box mt={2} fontSize="sm" color="gray.600">
              The section will be created last in the existing sequence.
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              onClick={handleAddNewSection}
              isDisabled={!newSectionName.trim()}
            >
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

        <Text mb={2} fontSize="md" fontWeight="bold">
          Sections
        </Text>

        {(isPsetEditing) && ( 
         <Box textAlign="left" mt={4}>
            <Button
                mb={2} 
                colorScheme="purple"
                size="sm"
                borderRadius="sm"
                onClick={onOpen}
                isDisabled={!(isPsetEditing)}
                >
                + Section
             </Button>
            </Box>
            )}

        {practiceSetSections.length === 0 ? (
          <Text fontSize="sm" color="gray.500">
            No sections added yet.
          </Text>
        ) : (
          <Accordion allowMultiple defaultIndex={practiceSetSections.map((_, i) => i)}>
            {practiceSetSections.map((section) => (
              <AccordionItem
                key={section.practice_set_section_id}
                border="1px solid"
                borderColor="gray.200"
                borderRadius="sm"
                
                mb={2}
              >
                {({ isExpanded }) => (
                  <>
                    <AccordionButton _expanded={{ bg: "gray.100" }}>
                      <Flex flex="1" align="center" justify="space-between">
                        <HStack spacing={3}>
                          <Badge colorScheme="blue">
                            Section # {section.sequence_number}
                          </Badge>
                          <Text fontWeight="semibold">
                            {section.title}
                          </Text>
                        </HStack>
                      </Flex>
                      <AccordionIcon />
                    </AccordionButton>

                    <AccordionPanel pb={4} >

                        <Box
                        p={4}
                        borderRadius="md"
                        bg={cardbg}
                        boxShadow="sm"
                        >
                        <Flex align="flex-start" gap={3}>
                    
                            {/* Title + Description Area (takes remaining width) */}
                            <Box flex="1">
                            {!isPsetEditing && (
                                <>
                                <Text fontSize="lg" fontWeight="semibold" lineHeight="1.2">
                                    {section.title || "–"}
                                </Text>
                                </>
                            )}
                    
                            {isPsetEditing && section && (
                                <VStack spacing={1} align="stretch">
                                <Input
                                    name="title"
                                    variant="flushed"
                                    fontSize="lg"
                                    fontWeight="semibold"
                                    px={0}
                                    value={section.title}
                                    onChange={(e) =>
                                            handleSectionInputChange(section.practice_set_section_id, e)
                                            }
                                    _focus={{ boxShadow: "none" }}
                                />
                    
                                </VStack>
                            )}
                            </Box>
                    
                            {/* Delete Icon — gets its OWN space now */}
                            {isPsetEditing && (practiceSetSections.length==section.sequence_number) && (
                            <IconButton
                                aria-label="Delete Exam"
                                icon={<FiTrash />}
                                variant="ghost"
                                size="lg"
                                color="gray.500"
                                alignSelf="center"
                                _hover={{ color: "red.500", bg: "transparent" }}
                                onClick={() => {
                                if (window.confirm("Delete this section? This cannot be undone.")) {
                                    handleDeletePracticeSetSection(section.practice_set_section_id);
                                }
                                }}
                            />
                            )}
                        </Flex>
                            {(isPsetEditing) && ( 
                                <Button
                                mt={2}
                                colorScheme="teal"
                                size="sm"
                                borderRadius="sm"
                                onClick={() => handleUpdatePracticeSetSection(section)}
                                >
                                Commit
                                </Button>
                                )} 
                        </Box>

                        {(isPsetEditing) && ( 
                            <Box textAlign="left" mt={4}>

                                <Button
                                mt={2}
                                colorScheme="pink"
                                size="sm"
                                borderRadius="sm"
                                onClick={() => {
                                
                                    setActiveSection(section);   // 🔑 THIS IS THE FIX
                                    onGroupNewOpen();
                                }}
                                >
                                + Group
                                </Button>

                            </Box>
                            )}
                        {/* Modal for adding a group to THIS section */}
                        <Modal isOpen={isGroupNewOpen} onClose={onGroupNewClose} isCentered>
                            <ModalOverlay />
                            <ModalContent>
                            <ModalHeader>Add Group to Section</ModalHeader>
                            <ModalCloseButton />

                            <ModalBody>
                                {/* Group dropdown */}
                                
                                <FormControl isRequired>
                                <Input placeholder="Enter new Group Name *" value={newGroupName} onChange={(e) => setNewGroupName(e.target.value)} />
                                
                                </FormControl>

                                <Box mt={2} fontSize="sm" color="gray.600">
                                Only groups not already used in this practice set are shown.
                                </Box>
                            </ModalBody>

                            <ModalFooter>
                                <Button variant="ghost" onClick={onGroupNewClose}>
                                Cancel
                                </Button>

                                <Button
                                colorScheme="blue"
                                ml={3}
                                isDisabled={newGroupName === ""}
                                onClick={() => {
                                    if (!activeSection) return;
                                    handleAddNewGroup(activeSection.practice_set_section_id);
                                }}
                                >
                                Confirm
                                </Button>
                            </ModalFooter>
                            </ModalContent>
                        </Modal>

                        {/* Existing groups */}
                        {section.practice_set_groups.length === 0 ? (
                            <Text fontSize="sm" color="gray.500" mt={3}>
                            No groups in this section.
                            </Text>
                        ) : (
                            <SimpleGrid columns={2} spacing={3} mt={3}>
                            {section.practice_set_groups.map((grp) => (
                                <Box
                                key={grp.practice_set_group_id}
                                >
                                <PracticeSetGroupQsets
                                    practiceSetId={section.practice_set_id}
                                    sectionId={section.practice_set_section_id}
                                    groupId={grp.practice_set_group_id}
                                    isPsetEditing={isPsetEditing}

                                    availableQuestionSets={availableQuestionSets}
                                    allQuestionSets={allQuestionSets}

                                    onCommitComplete={refreshAvailabilityAfterCommit}

                                    onGroupDeleted={handleGroupDeleted}
                                    canDelete={isLastGroup(section.practice_set_section_id, grp.practice_set_group_id, grp.sequence_number)}
                                />
                                </Box>
                            ))}
                            </SimpleGrid>
                        )}
                    </AccordionPanel>

                  </>
                )}
              </AccordionItem>
            ))}
          </Accordion>
        )}
  


    </Box>
  );
};

export default PracticeSetSections;
